import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {
  private translations: string = '';

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    const locale = environment.config.language || 'en';
    // English is the source locale, so Angular can use the compiled source
    // strings directly without holding bootstrap for the English XLF request.
    if (locale === 'en') {
      this.translations = '';
      return Promise.resolve();
    }
    const exchange = environment.config.EXCHANGE_NAME_L === 'burnx' ? 'burnx' : 'chainex';
    // Use the new path in assets
    const url = `assets/i18n/${exchange}/ts/messages.${locale}.xlf`;

    return lastValueFrom(this.http.get(url, { responseType: 'text' }))
      .then(translations => {
        this.translations = translations;
      })
      .catch(error => {
        console.error(`Error loading translations from ${url}`, error);
        if (locale !== 'en') {
          const fallbackUrl = `assets/i18n/${exchange}/ts/messages.en.xlf`;
          return lastValueFrom(this.http.get(fallbackUrl, { responseType: 'text' }))
            .then(fallback => {
              this.translations = fallback;
            })
            .catch(fallbackError => {
              console.error(`Error loading fallback translations from ${fallbackUrl}`, fallbackError);
            });
        }
        return Promise.resolve();
      });
  }

  getTranslations(): string {
    return this.translations;
  }
}
